import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import {
  getProductDetail,
  getProductImageDetail,
  getProductRelated,
} from "../../redux/actions/products_actions";

const Card = ({ ...props }) => {
  const renderCardImage = (image) => {
    if (image) {
      return image;
    } else {
      return "";
    }
  };
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })

  let widthDetail = 300
  if(props.widthDetail)
    widthDetail = parseInt(props.widthDetail)

  const link = `/product-detail/${props.productId}`

  const [imageLoading, setImageLoading] = useState(true);

  const handleImageLoaded = () => {
    setImageLoading(false);
  }

  const loadProductDetail = () => {
    const id = props.productId;
    const keyword = ""
    window.scrollTo({top: 0, left: 0, behavior: 'smooth' })
    props.dispatch(getProductImageDetail(id, keyword)).then(res =>{
      if(res.payload){
        if(res.payload.productImage.lenght > 0) {
          props.dispatch(getProductDetail(id, keyword)).then(res =>{
            if(res.payload.product != undefined){
              props.dispatch(getProductRelated(res.payload.product.productId, res.payload.product.categoryName))
            }
            else{
              props.history.push('/')
            }
          })
        }
      }
    })
  }

  return (
    <>
      <div className="row productItem" style={{ paddingLeft:0, paddingRight:0, marginRight:25, marginLeft:25 }}>
        <NavLink to={link} onClick={loadProductDetail} style={{color:"black"}}>
          <div>
            { imageLoading && <Skeleton height={140}/> }
            <img src={renderCardImage(props.image)} className="productImage" style={{ width: widthDetail }} onLoad={handleImageLoaded.bind(this)} />
            <div className="text-center">
                <b>{props.productName || <Skeleton />}</b>
                <br/>
                {props.notes || <Skeleton />}
                <br/>
                {formatter.format(props.price) || <Skeleton />}
            </div>
            <div className="text-center" style={{ marginTop:"5%", fontSize:15 }} >
              <i className="fas fa-chevron-right" id="arrowIcon"></i>
              <hr className="divider" />
            </div>
          </div>
        </NavLink>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    products: state.products,
  };
};
export default connect(mapStateToProps)(Card);